import { useEffect, useState } from "react";
import { Row, Col } from "react-flexbox-grid";

import { PageWrapper, Fab } from "components";
import { ListContact } from "components/Contact";

import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";
import { fetchBackend } from "helpers";

import Typography from "@material-ui/core/Typography";

const Contacts = ({ setLoading }) => {
  const [currentData, setDataSource] = useState([]);
  const gContext = useGlobalContext();

  useEffect(() => {
    const id = gContext.currentUser._id;

    const getInitialState = async () => {
      const { error, response } = await fetchBackend({
        url: `contact/user/${id}`,
      });
      setLoading(false);

      if (!error) {
        setDataSource(response);
      } else {
        gContext.toggleAlert({
          message:
            "Hubo un error al intentar obtener los contactos, revisa tu conexión a internet",
          type: "error",
        });
      }
    };
    id && getInitialState();
  }, [gContext.currentUser]);

  return (
    <>
      <PageWrapper
        isBack={false}
        header={
          <Row start="xs">
            <Col md={12}>
              <Row center="xs">
                <h1>Contactos</h1>
              </Row>
            </Col>
          </Row>
        }
      >
        <Col md={12}>
          <Row center="xs">
            <Typography variant="body2" component="p">
              Mi número: &nbsp;
              <strong>{gContext.currentUser?.phoneNumber}</strong>
            </Typography>
          </Row>
          <Row className="ph2 pt3">
            <Typography variant="button" color="primary">
              Números de seguridad
            </Typography>
          </Row>

          <ListContact data={currentData} />
        </Col>
      </PageWrapper>
      <Fab onClick={() => gContext.toggleContactModal(null)} />
    </>
  );
};

export default withLoader(Contacts, "Cargando contactos");
